import img from '@/img1'
import jsPDF from 'jspdf'

var certificateModule = (function(){
    
    return {
        generateCertificate: function(data){
            var imageData = img;
            //create document
            var doc = new jsPDF();
            
            //add image
            doc.addImage(imageData, 'JPEG', 15, 40, 180, 140);
            
            // doc.addImage(imageData, 'JPEG', 15, 15, 180, 265);
            
            //add title
            doc.setFont("times");
            doc.setFontType("italic");
            doc.setTextColor(29, 210, 242);
            doc.setFontSize(21);
            doc.text(105, 73, 'TYPING SPEED CERTIFICATE', 'center');
            
            //add text
            doc.setTextColor(96, 96, 96);
            doc.setFontSize(14);
            doc.text(105, 83, 'This Certificate is Hereby Awarded to: ', 'center');
            
            //add name
            doc.setTextColor(29, 210, 242);
            doc.setFontSize(19);
            doc.text(105, 90, data.name, 'center');
            
            //add text
            doc.setTextColor(96, 96, 96);
            doc.setFontSize(14);
            doc.text(105, 100, 'For Achieving Results noted below as documented', 'center');
            doc.text(105, 107, 'and verified by Free Typing Test.', 'center');
            
            //add results
            doc.text(105, 117, 'Level: ' + data.level, 'center');
            doc.text(105, 124, 'Average Speed: ' + data.wpm + ' wpm', 'center');
            doc.text(105, 131, 'Accuracy: ' + data.accuracy + '%', 'center');
            
            //add date
            var date = new Date();
            date = date.toLocaleDateString();
            doc.text(120, 140, 'Awarded on: ' + date);
            
            //add brand
            doc.setFontSize(14);
            doc.text(120, 148, 'Free Typing Test');

            doc.setFontSize(10);
            doc.text(120, 152, 'free-typingtest.firebaseapp.com');
            
            //save document
            doc.save('certificate.pdf');
        }
    }
})();

export default certificateModule;


// WEBPACK FOOTER //
// ./src/certificateModule.js